import { useContext } from "react";

import { useLanguageSpecificationApi } from "../../../../common/api/orders-api/language-specification/useLanguageSpecificationApi";
import { LanguageSpecificationListingContext } from "../../listing/context/LanguageSpecificationListingContext";
import { CreateLanguageSpecificationFormInputs } from "./CreateLanguageSpecificationForm";

export const useCreateLanguageSpecificationForm = () => {
    const { createLanguageSpecification: createSpecification } = useLanguageSpecificationApi();
    const { add: addLanguageSpecificationToContext } = useContext(LanguageSpecificationListingContext);

    const createLanguageSpecification = async ({ name, codeSource }: CreateLanguageSpecificationFormInputs) => {
        const response = await createSpecification({
            name,
            codeSource: Number(codeSource)
        });

        addLanguageSpecificationToContext({
            id: response.entityId,
            name,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        createLanguageSpecification
    };
};
